import {Component, Mixins} from 'vue-property-decorator';
import CustomPropertyDataMixin from '@/components/product/customProperty/CustomPropertyDataMixin';
import {getMallsConfigurationsByKey} from '@/utils/commonUtils';

@Component
export default class CustomPropertyMethodsMixin extends Mixins(CustomPropertyDataMixin) {
  public search(page: number = 1): void {
    this.$nextTick((): void => {
      const params: {[propName: string]: any} = {};

      Object.keys(this.searchParams).forEach((prop: any): void => {
        if (this.searchParams[prop] !== -100 && this.searchParams[prop] !== '') {
          Object.assign(params, {[prop]: this.searchParams[prop]});
        }
      });

      Object.assign(params, {
        periodInfo: {
          type: 'REGISTER_DATE',
          period: {
            startYmdt: '2000-01-01 00:00:00',
            endYmdt: this.today
          }
        },
        customPropertyValueNos: this.$route.params.propertyValueNo.split(','),
        page,
        saleSettingStatus: {isAll: false, types: ['AVAILABLE_FOR_SALE','STOP_SELLING']}
      });

      const tuiGrid = (this.$refs.gridArea as any).$refs.tuiGrid;
      tuiGrid.invoke('setColumns', this.gridProps.columns);

      this.$api.postProductsSearch({data: params} as any).then(({data}): void => {
        for (let i = 0; i < data.contents.length; i++) {
          data.contents[i].saleDateTime = data.contents[i].salePeriod.startYmdt + ' ~ ' + data.contents[i].salePeriod.endYmdt;
        }
        this.productContents = Object.assign({}, data);
        this.gridProps.pageOptions.perPage = this.searchParams.size || 0;
        this.gridProps.pageOptions.page = page;
        this.gridProps.pageOptions.totalCount = data.totalCount;
        this.popupResize();
      });
    });
  }

  public popupResize(): void {
    let contentWidth = $('#container').width() + 30;
    let contentHeight = $('.content').height() + 106;
    window.resizeTo(contentWidth, contentHeight);
  }

  public pageSizeChange(): void {
    this.$nextTick((): void => {
      this.search();
    });
  }

  private close(): void {
    window.close();
  }

  public created(): void {
    let getCustomPropertyData = {
      params: {
        propertyValueNo: this.$route.params.propertyValueNo
      }
    };
    this.$api.getCustomPropertiesValues(getCustomPropertyData).then(({data}): void => {
      this.customPropertySummaries = Object.assign({}, data);
    });

    Object.assign(this.gridProps.columns, {...this.defaultDisplayOrder});
    this.search();

    getMallsConfigurationsByKey(this, 'MALL_PRODUCT').then((responses: any): void => {
      responses.forEach((item: any): void => {
        this.productDetailUrlObj[item.mallNo] = item.productDetailUrl;
      });
    });
  }
  public mounted(): void {}
}
